let box2 = document.querySelector(".box2");
let tabItem1but = document.querySelector(".box2-content .text2 .switch-but");
let tabItem1 = document.querySelector(".box2-content .text2 .switch-but .but");
let tabItem2 = document.querySelectorAll(".box2-content .text2>span");
let tabItem3 = document.querySelectorAll(".box2-content .text3>div");
let tabItem4 = document.querySelectorAll(".box2-content .top .svg");
let tabItem5 = document.querySelectorAll(".box2-content .bottom .right picture");

let tabItem6 = document.querySelectorAll(".box4-content .tab-list li");
let tabItem7 = document.querySelectorAll(".box4-content .tab-content li");

let tabItem8 = document.querySelectorAll(".box8-content .text-item .but>div");
let tabItem9 = document.querySelectorAll(".box8-content .text-item.item2 .right>picture");

let tabItem10 = document.querySelectorAll(".box9-content .tab-list .tab-li li");
let tabItem11 = document.querySelectorAll(".box9-content .tab-list .tab-text p");
let tabItem12 = document.querySelectorAll(".box9-content-img .img-list picture");


let tabItem1true = true



tabItem6.forEach((link,index) => {
      
  link.addEventListener('click', (e)=>{

    tabItem6.forEach(item => {
      item.classList.remove("active");
    })
    tabItem7.forEach(item => {
      item.classList.remove("active");
    })

    tabItem6[index].classList.add("active");
    tabItem7[index].classList.add("active");
  })

  link.addEventListener('mouseover', (e)=>{

    tabItem6.forEach(item => {
      item.classList.remove("active");
    })
    tabItem7.forEach(item => {
      item.classList.remove("active");
    })

    tabItem6[index].classList.add("active");
    tabItem7[index].classList.add("active");
  })

})

tabItem8.forEach((link,index) => {
      
  link.addEventListener('click', (e)=>{

    tabItem8.forEach(item => {
      item.classList.remove("active");
    })
    tabItem9.forEach(item => {
      item.classList.remove("active");
    })

    tabItem8[index].classList.add("active");
    tabItem9[index].classList.add("active");
  })

  link.addEventListener('mouseover', (e)=>{

    tabItem8.forEach(item => {
      item.classList.remove("active");
    })
    tabItem9.forEach(item => {
      item.classList.remove("active");
    })

    tabItem8[index].classList.add("active");
    tabItem9[index].classList.add("active");
  })

})

tabItem10.forEach((link,index) => {
      
  link.addEventListener('click', (e)=>{

    tabItem10.forEach(item => {
      item.classList.remove("active");
    })
    tabItem11.forEach(item => {
      item.classList.remove("active");
    })
    tabItem12.forEach(item => {
      item.classList.remove("active");
    })

    tabItem10[index].classList.add("active");
    tabItem11[index].classList.add("active");
    tabItem12[index].classList.add("active");
  })

  link.addEventListener('mouseover', (e)=>{

    tabItem10.forEach(item => {
      item.classList.remove("active");
    })
    tabItem11.forEach(item => {
      item.classList.remove("active");
    })
    tabItem12.forEach(item => {
      item.classList.remove("active");
    })

    tabItem10[index].classList.add("active");
    tabItem11[index].classList.add("active");
    tabItem12[index].classList.add("active");
  })

})

function initResponsiveVideo({
    wrapper,
    videoId,
    firstFrameId,
    lastFrameId,
    sources,
    infoSelector = null,
    infoActiveClass = "active",
    replayBtnId = null
  }) {
    const video = document.getElementById(videoId);
    const firstFrame = document.getElementById(firstFrameId);
    const lastFrame  = document.getElementById(lastFrameId);
    const container  = document.querySelector(wrapper);
    const replayBtn  = replayBtnId ? document.getElementById(replayBtnId) : null;
    const infoElement = infoSelector ? document.querySelector(infoSelector) : null;
  
    if (!video || !firstFrame || !lastFrame || !container) {
      console.warn("initResponsiveVideo: 元素缺失");
      return;
    }
  
    // 设备类型
    const width = window.innerWidth;
    let deviceType = width <= 750 ? "mobile" : width <= 1024 ? "tablet" : "pc";
    const deviceSources = sources[deviceType];
  
    if (!deviceSources || !Array.isArray(deviceSources)) {
      console.warn(`initResponsiveVideo: ${deviceType} 的视频资源不正确`);
      return;
    }
  
    video.innerHTML = "";
    deviceSources.forEach(item => {
      const source = document.createElement("source");
      source.src = item.src;
      source.type = item.type;
      video.appendChild(source);
    });
  
    // 初始化
    function resetState() {
      video.style.opacity = "1";
      firstFrame.style.opacity = "0";
      lastFrame.style.opacity = "0";
  
      if (infoElement) {
        infoElement.classList.remove(infoActiveClass);
      }
  
      if (replayBtn) {
        replayBtn.classList.remove("show");
      }
  
      video.currentTime = 0;
    }
  
    resetState(); // 初始化一次
  
    // 视频加载 → 隐藏首帧
    video.addEventListener("loadeddata", () => {
      firstFrame.style.opacity = "0";
    });
  
    // 视频播放结束
    video.addEventListener("ended", () => {
      video.style.opacity = "0";
      lastFrame.style.opacity = "1";
  
      if (infoElement) infoElement.classList.add(infoActiveClass);
  
      if (replayBtn) replayBtn.classList.add("show"); // 显示重播按钮
    });
  
    if (replayBtn) {
      replayBtn.addEventListener("click", () => {
        resetState();   // 全部恢复初始状态
        video.play();   // 重新播放
      });
    }
  }

initResponsiveVideo({
  wrapper: '.box4-video1',
  videoId: 'video1',
  firstFrameId: 'video1FirstFrame',
  lastFrameId: 'video1LastFrame',
  sources: {
    pc: [
      { src: "http://www.boox.com/wp-content/uploads/2026/03/PC端3-1.mov", type: "video/quicktime" },
      { src: "https://cdn.shopify.com/videos/c/o/v/4eaaaab330a74f97987b4a3ff41c9978.webm", type: "video/webm" },
      { src: "https://cdn.shopify.com/videos/c/o/v/3bcf1711b4a6476994ff6beffe11a7b8.mp4", type: "video/mp4" }
    ],
    tablet: [
      { src: "http://www.boox.com/wp-content/uploads/2026/03/Tablet03-1.mov", type: "video/quicktime" },
      { src: "https://cdn.shopify.com/videos/c/o/v/1770ed7f28fe4b919020f48f8fa49d47.webm", type: "video/webm" },
      { src: "https://cdn.shopify.com/videos/c/o/v/875720c1a6e545d19d69eaa76a9880d5.mp4", type: "video/mp4" }
    ],
    mobile: [
      { src: "https://cdn.shopify.com/videos/c/o/v/379fa1c0d5a34795b90995b21c5b8ac8.mp4", type: "video/mp4" }
    ]
  },

  // 不再固定，可传任何选择器
  infoSelector: "",
  infoActiveClass: "active",
  replayBtnId: ""
});

initResponsiveVideo({
  wrapper: '.box4-video2',
  videoId: 'video2',
  firstFrameId: 'video2FirstFrame',
  lastFrameId: 'video2LastFrame',
  sources: {
    pc: [
      { src: "http://www.boox.com/wp-content/uploads/2026/03/PC端3-2.mov", type: "video/quicktime" },
      { src: "https://cdn.shopify.com/videos/c/o/v/48a17ddf2856499a878710d742d56408.webm", type: "video/webm" },
      { src: "https://cdn.shopify.com/videos/c/o/v/ee9644aae2b84943b3a2de0e08457a2b.mp4", type: "video/mp4" }
    ],
    tablet: [
      { src: "http://www.boox.com/wp-content/uploads/2026/03/Tablet03-2.mov", type: "video/quicktime" },
      { src: "https://cdn.shopify.com/videos/c/o/v/3fc29115292e4ea0967fa54b57f67937.webm", type: "video/webm" },
      { src: "https://cdn.shopify.com/videos/c/o/v/0f0ce9700548475cadcfdcc66418b53e.mp4", type: "video/mp4" }
    ],
    mobile: [
      { src: "https://cdn.shopify.com/videos/c/o/v/4ee38f6d943c452ea06a64bf540c1c39.mp4", type: "video/mp4" }
    ]
  },

  // 不再固定，可传任何选择器
  infoSelector: "",
  infoActiveClass: "active",
  replayBtnId: ""
});

initResponsiveVideo({
  wrapper: '.box3-video',
  videoId: 'video3',
  firstFrameId: 'video3FirstFrame',
  lastFrameId: 'video3LastFrame',
  sources: {
    pc: [
      { src: "https://cdn.shopify.com/videos/c/o/v/f8864e00edc14f33bc777d8c2c39efb3.mp4", type: "video/mp4" }
    ],
    tablet: [
      { src: "https://cdn.shopify.com/videos/c/o/v/f8864e00edc14f33bc777d8c2c39efb3.mp4", type: "video/mp4" }
    ],
    mobile: [
      { src: "https://cdn.shopify.com/videos/c/o/v/dceb6951940b4fa7bf9a1331bda67084.mp4", type: "video/mp4" }
    ]
  },

  // 不再固定，可传任何选择器
  infoSelector: ".div-img-video .video3-note",
  infoActiveClass: "active",
  replayBtnId: "video3-replay"
});


ScrollTrigger.create({
  trigger: '.box2',
  start: 'top top',
  end:'+=140% bottom',
  scrub: true,
  pin:true,
  onUpdate(self){
      let imgIndex = self.progress;
      if(imgIndex>=0.5){
        let tabItem1Index = 1
  
        box2.classList.add("active");
        tabItem1.classList.add("active");

        tabItem2.forEach(item => {
          item.classList.remove("active");
        })
        tabItem3.forEach(item => {
          item.classList.remove("active");
        })
        tabItem4.forEach(item => {
          item.classList.add("active");
        })
        tabItem5.forEach(item => {
          item.classList.remove("active");
        })

        tabItem2[tabItem1Index].classList.add("active");
        tabItem3[tabItem1Index].classList.add("active");
        tabItem5[tabItem1Index].classList.add("active");
      }else{

        let tabItem1Index = 0
      
        box2.classList.remove("active");
        tabItem1.classList.remove("active");

        tabItem2.forEach(item => {
          item.classList.remove("active");
        })
        tabItem3.forEach(item => {
          item.classList.remove("active");
        })
        tabItem4.forEach(item => {
          item.classList.remove("active");
        })
        tabItem5.forEach(item => {
          item.classList.remove("active");
        })

        tabItem2[tabItem1Index].classList.add("active");
        tabItem3[tabItem1Index].classList.add("active");
        tabItem5[tabItem1Index].classList.add("active");
      }
      
  }
})

const splide = new Splide('#box7-splide', {
  type   : 'loop',
  perPage: 2,
  focus  : 'center',
  lazyLoad: 'nearby',
  updateOnMove: true,
  arrows: false, 
  breakpoints: {
    1024: {
      perPage: 1.5
    },
    750: {
      perPage: 1.5
    },
  }
}).mount();


splide.on('click', function (slide) {
  splide.go(slide.index);
});